// Mirror of backend core.normalize_url: make a typed link usable.
const SCHEME = /^[a-z][a-z0-9+.-]*:/i;
const DOMAIN = /^(?:www\.)?[a-z0-9-]+(?:\.[a-z0-9-]+)+(?::\d+)?(?:[/?#].*)?$/i;
const EMAIL = /^[^@\s/<>]+@[^@\s/<>]+\.[a-z]{2,}$/i;
const PHONE = /^\+?\d[\d\s().-]{5,}$/;

export function normalizeUrl(input) {
  let u = (input || '').trim();
  if (!u || u.startsWith('#') || u.startsWith('{{')) return u;
  u = u.replace(/^(https?)\s*:?\/{0,2}\s*/i, (_, s) => `${s.toLowerCase()}://`);
  u = u.replace(/^(mailto|tel)\s*:\s*/i, (_, s) => `${s.toLowerCase()}:`);
  if (u.startsWith('//')) return `https:${u}`;
  if (/^tel:/i.test(u)) return `tel:${u.slice(4).replace(/[\s().-]/g, '')}`;
  if (SCHEME.test(u)) return u.replace(/ /g, '%20');
  if (EMAIL.test(u)) return `mailto:${u}`;
  if (PHONE.test(u) && !u.startsWith('/')) return `tel:${u.replace(/[\s().-]/g, '')}`;
  if (DOMAIN.test(u)) return `https://${u.replace(/ /g, '%20')}`;
  return u.replace(/ /g, '%20');
}

export function describeUrl(u) {
  if (!u) return '';
  if (u.startsWith('mailto:')) return `Email link → ${u.slice(7)}`;
  if (u.startsWith('tel:')) return `Phone link → ${u.slice(4)}`;
  if (u.startsWith('#')) return 'Jump to a heading on this page';
  if (u.startsWith('{{')) return 'Mailmerge field — filled in per recipient';
  if (/^https?:\/\//i.test(u)) return `Opens ${u}`;
  if (u.startsWith('/')) return `Page on this site → ${u}`;
  return 'Relative link (will be resolved against this site)';
}
